export const COVERAGE_CITIES = [
  { name: "Noida", status: "live" },
  { name: "Gurugram", status: "request" },
  { name: "Delhi", status: "request" },
  { name: "Faridabad", status: "request" },
  { name: "Nainital", status: "request" },
  { name: "Haridwar", status: "request" },
  { name: "Rishikesh", status: "request" },
  { name: "Vaishno Devi", status: "request" },
];
